import { render, staticRenderFns } from "./ModalDeleteReport.vue?vue&type=template&id=1b110213&scoped=true"
import script from "./ModalDeleteReport.vue?vue&type=script&lang=js"
export * from "./ModalDeleteReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b110213",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b110213')) {
      api.createRecord('1b110213', component.options)
    } else {
      api.reload('1b110213', component.options)
    }
    module.hot.accept("./ModalDeleteReport.vue?vue&type=template&id=1b110213&scoped=true", function () {
      api.rerender('1b110213', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalDeleteReport.vue"
export default component.exports